import { useParams } from "react-router-dom";
import QuestionBuilderTranslation from "./QuestionBuilderTranslation";

const StudyFormTranslationBuilder = () => {
  const { id: studyId, formId } = useParams();
  return (
    <QuestionBuilderTranslation
      studyId={studyId || ""}
      formId={formId || ""}
      type="study"
    />
  );
};

export default StudyFormTranslationBuilder;
